export default "__VITE_ASSET__aCoaDtMH__"